import { render, staticRenderFns } from "./SignupBlock.vue?vue&type=template&id=8f246406&"
import script from "./SignupBlock.vue?vue&type=script&lang=js&"
export * from "./SignupBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports